import React from 'react';
import '../.././components/css/popupstyle.css';
import $ from 'jquery';
import { userService } from '../../_services';

class AssignGroupNumber extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            WhAdvanceSetting: []
        };
    }
    componentDidMount() {
        this.fetchAdvanceSetting('', '', '0');
    }
    handleSaveSubmit = (e) => {
        let userType = $('#userType').val();
        if (userType == 'Web Campaign') {
            this.props.closeAssignGroupPopup();
            this.props.openCampaignPopup('', '', '', '', userType);
        } else {
            this.props.closeAssignGroupPopup();
            this.props.openEditScreenPopup('', '', '', '', userType, this.props.SelectedGroupNumber);
        }
    }
    handleBack = () => {
        this.props.closeAssignGroupPopup();
        this.props.openManageGroup(this.props.SelectedGroupNumber, this.props.MaxComm, this.props.cPagin, this.props.cSearch, '', '', this.props.reopenFlag, this.props.allData);
    }
    fetchAdvanceSetting(roleName, roleType, id) {
        try {
            let whid = this.state.userdata.wholesaler_Id.toString();
            userService.GetAdvanceSetting(roleName, roleType, whid).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ WhAdvanceSetting: apidata[0].settings[0] });
                            setTimeout(() => {
                                $('.popup').addClass('mfp-ready');
                                $('.popup').addClass('mfp-bg');
                                $('.popup').addClass('mfp-with-anim');
                            }, 5);
                        }
                    }
                    catch (error) {
                    }
                }
            );
        }
        catch (error) {
        }
    }
    render() {
        return (
            <div className="tool-section report">
                <div className='popup mfp-zoom-in report-section commission-edit popup-right-radius'>
                    <div className='popup_inner'>

                        <h1>{this.props.text}<button onClick={this.handleBack}>X</button></h1>

                        <div id="dashboard_header" className="big_dash_header">
                            <div id="dashboard_header_inner">
                                <div id="dashboard-back-button"></div>
                                <div id="dashboard_header_select">
                                    <form>
                                        <div className="selectSection payout">
                                            <label>Select a User Type</label>
                                            <span className="down-arrow"></span>
                                            <select id="userType" className="form-control disinput">
                                                {
                                                    this.state.WhAdvanceSetting.isBroker == true ? <option value="Broker">Broker</option> : null
                                                }
                                                <option value="Distributor">Distributor</option>
                                                <option value="Email Campaign">Email Campaign</option>
                                                <option value="IBO/Marketplace">IBO/Marketplace</option>
                                                <option value="Mail Campaign">Mail Campaign</option>
                                                <option value="SMS Campaign">SMS Campaign</option>
                                                <option value="Web Campaign">Web Campaign</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="pop-btn ungap">
                                            <input type="button" className='btn save-btn' onClick={this.handleSaveSubmit} value="Submit" />
                                            <input type="button" onClick={this.handleBack} className="btn cancel" value="Cancel" />
                                        </div>

                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
export default AssignGroupNumber;